import BaseService from './BaseService';

class RouteService extends BaseService {
    getRoutes = () => this.get('/warehouse/route');
}

export default new RouteService();
